<script>
    import Modal from './Modal.svelte';
	import { modal } from './stores.js';
    import PopupShareNote from './PopupShareNote.svelte';
    export let postUid;
</script>

<Modal show={$modal}>
    <PopupShareNote postUid={postUid} />
</Modal>